// Instellingen die het dashboard aansturen. Hier aanpassen, niet verspreid door de code.

// Het dashboard is getekend voor een 1920x1080 scherm en wordt naar het echte scherm geschaald.
export const designWidth = 1920;
export const designHeight = 1080;

// Kolom 2 wisselt af tussen het podium en de rest van de ranglijst.
export const podiumViewMs = 30000;
export const restViewMs = 10000;

// Lijst "Verkochte diensten": ruimte tussen de rijen en hoe snel hij doorrolt als hij te lang is.
export const rowGapMin = 18; // px
export const rowGapMax = 40; // px
export const marqueeSpeed = 32; // px per seconde

// Ophalen van data.
export const cacheMs = 300000; // 5 minuten hergebruiken voor we opnieuw ophalen
export const retryMs = 20000; // na een mislukte poging zo lang wachten
export const tokenCheckMs = 30000; // controleer of de gebruiker nog ingelogd is
export const monthCheckMs = 60000; // controleer of de maand is omgeslagen
export const clockTickMs = 60000;

// Muisaanwijzer verbergen als er zo lang niets beweegt. Zie hooks/useIdleCursor.js.
export const idleCursorMs = 30000;

// Geluid. Het dashboard maakt zijn geluiden zelf, zie audio/audioEngine.js.
// Per scherm uit te zetten met ?sound=off achter de URL of met de knop in
// het animatielab.
export const soundVolume = 0.7; // 0 is stil, 1 is zo hard als de browser mag

// Het seintje, de aanloop en de aankondiging zijn het moment; die mogen boven
// de rest uit komen. 1 is even hard als al het andere. Zie accented in
// audio/cues.js voor welke drie dat zijn.
export const soundAccent = 1.6;

// Animaties bij nieuwe verkopen.
export const refreshMs = 60000; // hoe vaak we kijken of er iets is bijgekomen
// Wat er bij een verkoop valt is confetti, en hoeveel hangt af van het
// bedrag. Vanaf mediumDealAmount komt er een tweede bui overheen zodra de
// balk staat, en vanaf bigDealAmount nog een derde: het aantal buien is wat
// je van de andere kant van de ruimte ziet.
export const mediumDealAmount = 500;
export const bigDealAmount = 1000;

// Hoeveel confetti er over de aankondiging valt, als deel van een volle bui:
// 1 is de bui van het target, 0 zet hem uit. De kleinste verkoop krijgt
// saleConfettiMin, vanaf bigDealAmount is het saleConfettiMax, en daartussen
// loopt het op met het bedrag.
export const saleConfettiMin = 0.6;
export const saleConfettiMax = 1.2;
// Onder dit bedrag maken we geen feest van een record: anders staat er
// vuurwerk voor een verkoop van tien euro die toevallig de eerste was.
export const recordMinAmount = 500;

// En hetzelfde voor iemands eigen record. Die komt vaker langs dan het
// record van het hele bord - er zijn net zoveel eigen records als verkopers -
// dus de lat ligt hier hoger: pas vanaf dit bedrag krijgt het een kaart, en
// daaronder is het gewoon een verkoop. Zie hooks/useSaleEvents.js.
export const personalBestMinAmount = 750;

// Kijken of deze tv echt nog iets laat zien. De Pi blijft aan als de tv
// uitgaat, dus het beeld zelf is het enige eerlijke signaal: we tellen de
// frames en zakt dat lang genoeg onder de vloer, dan staat het scherm uit.
// Zie utils/screenAwake.js; per scherm bij te stellen met ?dark=, zie
// utils/device.js.
export const screenCheckMs = 2000; // hoe vaak we de frames tellen
export const screenMinFps = 3; // hieronder tekent dit scherm niet meer
export const screenDarkMs = 60000; // zo lang achter elkaar telt als tv uit

// Wanneer wat er ondertussen is verkocht de kaart "Verkopen gemist" krijgt
// in plaats van gewoon de volgende meting te zijn. Twee gevallen, en ze
// kunnen niet dezelfde drempel hebben:
//
// 1. De tv ging uit terwijl de Pi doorliep. Die tijd meten we echt, aan het
//    beeld zelf (zie utils/screenAwake.js), dus die mag kort staan.
// 2. Er viel niets te meten: de Pi uit, het tabblad dicht, of een tijd geen
//    netwerk. Dan is het enige bewijs het gat in de bewaarde stand, en dat
//    gat is bij een doodgewone ophaalronde al refreshMs groot. Deze moet er
//    dus ruim boven blijven, anders komt de kaart elke minuut voorbij.
//
// Zie hooks/useSaleEvents.js.
export const catchUpDarkMs = 60000; // 1 minuut gemeten donker
export const catchUpOfflineMs = 300000; // 5 minuten ongemeten stilte

// Toetsen 1..9/0 spelen op het echte dashboard een animatie af, zodat je ze
// op de tv kunt uitproberen. Uit: op de tv hoort niemand met een toets
// vuurwerk te kunnen starten. Testen doe je in het animatielab, dat je met
// de verborgen code bereikt.
export const testShortcuts = false;
